import {
  ApiKnowledgeProvider,
  StaticKnowledgeProvider,
  getAuthClient,
  type KnowledgeProvider,
} from "@cloudox/api-client";

/**
 * Resolve the Knowledge provider for the public preview.
 *
 *  1. Authenticated single-run API provider when `VITE_API_BASE_URL` +
 *     `VITE_RUN_ID` are set (optional live single-run preview).
 *  2. Otherwise a static bundle: `VITE_CONTENT_BASE_URL` or `/content`, which
 *     hosts `views/navigation.json`, `views/<key>.md`, and `quality.json`.
 *
 * The browser only ever sees URLs (+ a bearer token for the API path).
 */
export function createPreviewKnowledgeProvider(): KnowledgeProvider {
  const apiBase = import.meta.env.VITE_API_BASE_URL?.trim();
  const runId = import.meta.env.VITE_RUN_ID?.trim();
  if (apiBase && runId) {
    return new ApiKnowledgeProvider({
      baseUrl: apiBase,
      runId,
      getToken: () => getAuthClient()?.getIdToken(),
    });
  }
  const base = import.meta.env.VITE_CONTENT_BASE_URL?.trim() || "/content";
  return new StaticKnowledgeProvider({ baseUrl: base });
}
